import React, { useMemo } from 'react'

import { strings } from '@constants'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import { paths } from '@routes'
import { displayAmount } from '@utils'

const TopOrganisations = ({ top_organisations }) => {
	const _data = top_organisations
	const columns = useMemo(
		() => [
			{
				label: strings('organisation', 'id'),
				key: 'organisation_id',
				mobile: true,
			},
			{
				label: strings('organisation', 'name'),
				key: 'organisation_name',
				mobile: true,
			},
			{
				label: strings('revenue_in_cr'),
				key: 'revenue',
				mobile: true,
				renderer: (data) => displayAmount(data),
			},
			{
				label: strings(['last', 'invoice', 'date']),
				key: 'last_invoice_date',
				mobile: true,
			},
		],
		[]
	)

	const onRowClick = (data) => {
		if (!data?.organisation_id) {
			return
		}
		window.open(paths.admin_organisations_details_org(data?.organisation_id), '_blank')
	}

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Top Organisations</Heading>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={_data || []}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					onRowClick={onRowClick}
					rowClickable={true}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default TopOrganisations
